import React from 'react';
import Home from './screens/Home';
import 'leaflet/dist/leaflet.css';

function App() {
    return <Home />;
}

export default App;
